// Bilingual accessible names for icon-only buttons. Follows <html lang>, which LanguageContext keeps in sync.
const LABELS = {
  X: ['Close', 'Cerrar'], Send: ['Send', 'Enviar'], Share2: ['Share', 'Compartir'], ChevronRight: ['Next', 'Siguiente'],
  ChevronLeft: ['Previous', 'Anterior'], RefreshCw: ['Refresh', 'Actualizar'], CheckCircle: ['Mark as done', 'Marcar como hecho'],
  Copy: ['Copy', 'Copiar'], Play: ['Play', 'Reproducir'], Pause: ['Pause', 'Pausar'], Plus: ['Add', 'Agregar'], Back: ['Back', 'Atrás'], Dismiss: ['Dismiss', 'Descartar'],
  ShowPassword: ['Show password', 'Mostrar contraseña'], HidePassword: ['Hide password', 'Ocultar contraseña'],
};

export const a11yLabel = (icon) => {
  const [en, es] = LABELS[icon] || [icon, icon];
  return typeof document !== 'undefined' && document.documentElement.lang === 'es' ? es : en;
};
